export const truncateWithEllipsis = (string, maxLength) => {
    if (string?.length > maxLength) {
        // If maxLength is < 3 just return all 3 dots to simplify logic
        return string.slice(0, Math.max(maxLength - 3, 0)) + '...';
    } else {
        return string;
    }
};
